module.exports = __webpack_public_path__ + "img/bussiness_mobile_ky.7b880225.png";